export const ONLINE = 'online';
export const OFFLINE = 'offline';
export const NO_GATEWAY_ASSIGNED = 'no_gateway_assigned';
